import { useState } from "react";
import "./LeafBannerToast.scss";
import { IconClose } from "../../icons/IconClose/IconClose";

type BannerToastProps = {
  theme: "green" | "red" | "yellow" | "blue" | "dark";
  show: boolean;
  children?: React.ReactNode;
  closeFunction: () => void;
  id?: string;
};

export const LeafBannerToast = ({ theme, show, children, closeFunction, id }: BannerToastProps) => {
  const [isDismissed, setIsDismissed] = useState<boolean>(() => {
    if (id) {
      return sessionStorage.getItem(id) === "true";
    }
    return false;
  });

  const handleClose = () => {
    if (id) {
      sessionStorage.setItem(id, "true");
      setIsDismissed(true);
    }
    closeFunction();
  };

  const shouldShow = show && !isDismissed;

  return shouldShow ? (
    <div data-testid="leafBannerToast" role="alert" className={`leafBannerToast leafBannerToast__${theme}`}>
      <div className="leafBannerToast__message" role="status">
        {children}
      </div>
      <div
        data-testid="leafBannerToast__click"
        role={"button"}
        className="leafBannerToast__closeButton"
        onClick={handleClose}
        tabIndex={0}
        aria-label="Close notification"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleClose();
          }
        }}
      >
        <IconClose width={"0.875rem"} height={"1.313rem"} color={theme === "dark" ? "white" : "grey"} />
      </div>
    </div>
  ) : (
    <></>
  );
};
